import React from 'react';
import PropTypes from 'prop-types';

import './tableScrutiny.scss';
import Caret from 'components/caret';

const TableScrutiny = ({
  totalVotes,
  invalidVotes,
  whiteVotes,
  abstentionVotes,
  invalidPercent,
  whitePercent,
  abstentionPercent,
  participationPercent,
  isActive,
  currentCountPercent,
  difference
}) => (
  <div className="TableScrutiny">
    <table cellSpacing="0" cellPadding="0">
      <caption className="caption">
        Tabla que contiene el resumen del escrutinio
      </caption>
      <thead>
        <tr className="thead-row">
          <th className="th-highlight" scope="row">
            Resumen del escrutinio:
          </th>
          <td className="td-highlight" colSpan={2}>
            {!isActive && !Number.isNaN(difference) && (
              <div className="wrapper-participation">
                <p className="txt-participation">
                  Participación{' '}
                  <strong className="td-participation-strong">
                    {participationPercent}%
                  </strong>
                </p>
                <span className="td-participation-percent">
                  <Caret difference={difference} />
                  <span className="percent">%</span>
                </span>
              </div>
            )}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th className="th-title" scope="row">
            Votos contabilizados:
          </th>
          <td className="td-votes">{totalVotes}</td>
          <td className="td-percent">{currentCountPercent}%</td>
        </tr>
        <tr>
          <th className="th-title" scope="row">
            Abstenciones:
          </th>
          <td className="td-votes">{abstentionVotes}</td>
          <td className="td-percent">{abstentionPercent}%</td>
        </tr>
        <tr>
          <th className="th-title" scope="row">
            Votos en blanco:
          </th>
          <td className="td-votes">{whiteVotes}</td>
          <td className="td-percent">{whitePercent}%</td>
        </tr>
        <tr>
          <th className="th-title" scope="row">
            Votos nulos:
          </th>
          <td className="td-votes">{invalidVotes}</td>
          <td className="td-percent">{invalidPercent}%</td>
        </tr>
      </tbody>
    </table>
  </div>
);

TableScrutiny.propTypes = {
  totalVotes: PropTypes.string,
  invalidVotes: PropTypes.string,
  whiteVotes: PropTypes.string,
  abstentionVotes: PropTypes.string,
  invalidPercent: PropTypes.string,
  whitePercent: PropTypes.string,
  abstentionPercent: PropTypes.string,
  participationPercent: PropTypes.string,
  isActive: PropTypes.bool,
  currentCountPercent: PropTypes.string,
  difference: PropTypes.number
};

TableScrutiny.defaultProps = {
  totalVotes: '',
  invalidVotes: '',
  whiteVotes: '',
  abstentionVotes: '',
  invalidPercent: '',
  whitePercent: '',
  abstentionPercent: '',
  participationPercent: '',
  isActive: false,
  currentCountPercent: '',
  difference: 0
};

export default TableScrutiny;
